import { useState } from "react";
import INTOUCH_API from "../../services/Api";
import useModalActions from "../../hooks/useModalActions";
import { useNavigate } from "react-router-dom";
import useCookie from "../../hooks/useCookie";
import ROUTES from "../../utils/routes";

export default function useController() {
  const navigate = useNavigate();
  const { removeCookie } = useCookie();
  const { closeModal } = useModalActions();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteProfile = (e) => {
    e.preventDefault();
    setIsDeleting(true);
    INTOUCH_API.requestManager(
      "delete_user",
      null,
      () => {
        setIsDeleting(false);
        closeModal();
        removeCookie("token");
        navigate(ROUTES.LOGIN_PAGE);
      },
      () => {}
    );
  };
  return {
    deleteProfile,
    isDeleting,
  };
}
